module.exports = __webpack_public_path__ + "static/img/smart.248127cc.png";